<template>
  <EhouseCalculating />
</template>

<script>
import EhouseCalculating from "@/components/Calculatings/EhouseCalculating/index.vue";
export default {
  components: {
    EhouseCalculating,
  },
};
</script>

<style></style>
